export default {"src":"/_next/static/media/salad.797e6067.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};